import { Tooltip } from 'react-tippy'

import { InfoIcon } from '@phosphor-icons/react'

import AddVariablesButton from '@/common/components/AddVariablesButton/AddVariablesButton'

import * as Styles from './styles'

const InsertVariables = ({ onAddVariable, availableVariables, availableSections, disabled, tooltip }) => {
  return (
    <Styles.Container>
      <AddVariablesButton
        onAddVariable={onAddVariable}
        availableVariables={availableVariables}
        availableSections={availableSections}
        disabled={disabled}
      />
      <Tooltip title={tooltip}>
        <InfoIcon size={24} />
      </Tooltip>
    </Styles.Container>
  )
}

export default InsertVariables
